export default {
  title: '偽造対策管理',
  qrCodeList: 'QRコード一覧',
  scanRecords: 'スキャン記録',
};
